import { WorkBook } from 'xlsx/types';
import { ExcelTool } from '../../../../core/excel/excel_tool';


export function importKennzahlen(excel: ExcelTool, workBook: WorkBook, sheetSelected: string) {
    const rows = excel.getJSON(workBook, sheetSelected);
    const group_arr: any = rows[1];
    const key_arr: any = rows[3];
    const gewerk_arr: any = rows[4];
    const berechnet_arr: any = rows[5];

    const kennziffern_row = importRow(key_arr, rows[2]);
    const aufnahmeData = {
        keys: key_arr,
        groups: group_arr,
        kennziffern: kennziffern_row,
        gewerk_flag: gewerk_arr,
        berechnet_flag: berechnet_arr,
        daten: <Array<any>> []
    };
    console.log('Kennziffern:', kennziffern_row);
    for (let i = 6; i < rows.length; i++) {
        const row: any = rows[i];
        const lfd: number = +row[1];
        const betrieb  = row[2];
        const jahr: number = +row[3];
        // console.log('Row: ', lfd, betrieb, jahr);
        if (lfd && !isNaN(lfd) && betrieb && jahr && !isNaN(jahr)) {
            const rowData = importRow(key_arr, row);
            rowData.jahr = jahr;
            rowData.betrieb = betrieb;
            // console.log(rowData);
            aufnahmeData.daten.push(rowData);
        }
    }
    console.log(aufnahmeData);
    return aufnahmeData;
}

function importRow(key_arr: any, row: any) {
    const rowData: any = {};
    for (let j = 4; j < row.length; j++) {
        if (key_arr[j]) {
            const key = key_arr[j];
            const value = row[j];
            rowData[key] = value;
        }
    }
    return rowData;
}

